<template>
  <div class="select">
    <select
      v-model="timezoneSelect"
      :disabled="loading"
      class="form-control"
    >
      <optgroup
        v-for="timezoneGroup in timeZoneList"
        :key="`timezoneGroup-${timezoneGroup.name}`"
        :label="`${timezoneGroup.name} Time Zone`"
      >
        <option
          v-for="timezone in timezoneGroup.items"
          :key="`timezone-${timezone.id}`"
          :value="timezone.id"
        >
          {{ getGMT(timezone) }}
          {{ timezone.timezoneLast }}
        </option>
      </optgroup>
    </select>
  </div>
</template>

<script>
import axios from "axios";

export function getGMT({gmt_offset}) {
  const gmt_offset_abs = Math.abs(gmt_offset)
  let text = 'GMT';
  text += (gmt_offset > 0) ? '+' : '-'
  text += (gmt_offset_abs < 10) ? '0' : ''
  text += String(gmt_offset_abs)
  text += ':00'
  return text;
}

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      skipTZ: ['Africa', 'Arctic'],
      loading: false,
      items: [],
    };
  },
  computed: {
    timezoneSelect: {
      get() {
        return this.value;
      },
      set(value) {
        return this.$emit('input', value);
      },
    },
    timeZoneList() {
      const timezonesObj = (this.items || [])
        .reduce((ret, item) => {
          const timeZoneSplit = item.id.split('/');
          const timeZoneGroup = timeZoneSplit.slice(0, -1).join('/');

          if (!ret[timeZoneGroup]) ret[timeZoneGroup] = [];

          item.timezoneLast = timeZoneSplit.slice(-1)[0];
          ret[timeZoneGroup].push(item);

          return ret;
        }, {});

      const timezones = [];
      for (const [name, items] of Object.entries(timezonesObj)) {
        if (this.skipTZ.includes(name)) continue;
        items.sort((a, b) =>
          a.gmt_offset - b.gmt_offset ||
          a.timezoneLast.localeCompare(b.timezoneLast)
        );
        timezones.push({name, items});
      }

      return timezones
        .sort((a, b) => (a.name === 'Europe' ? -1 : b.name === 'Europe' ? 1 : 0));
    },
  },
  mounted() {
    this.fetch()
  },
  methods: {
    getGMT,
    async fetch() {
      if (this.items.length) return;

      this.loading = true;

      let items = [];
      let page = 1;
      const per_page = 1000;

      while (true) {
        try {
          const response = await axios.get(`/librarium/api/v1/sys/timezones`, {
            params: {page, per_page, hidden: false},
          });

          if (typeof response.data === 'string') break;
          if (!response.data.length) break;

          items = items.concat(response.data);

          if (response.data.length < per_page) break;
        } catch (error) {
          console.error('/librarium/api/v1/sys/timezones | error = ', error);
          throw error;
        }
        page++;
      }

      this.items = items;
      this.loading = false;
    },
  },
};
</script>

<style scoped>

</style>
